import React from 'react';
import { cn } from '../../utils';
import type { QCallInlineConfig } from '../../types';
import { ExpandedInlineWidget } from '../ui-styles/expanded-style';

export interface InlineWidgetProps {
  /** Widget configuration */
  config: QCallInlineConfig;
  /** Additional class names */
  className?: string;
}

/**
 * Inline widget component - embedded in page content
 * Renders different UI styles based on config.uiStyle
 */
export function InlineWidget({ config, className }: InlineWidgetProps) {
  const { uiStyle = 'expanded' } = config;

  // Inline widget uses expanded style by default for chat-like interface
  if (uiStyle === 'expanded' || uiStyle === 'default') {
    return <ExpandedInlineWidget config={config} className={className} />;
  }

  // Fallback to expanded style
  return <ExpandedInlineWidget config={config} className={className} />;
}
